import { render, staticRenderFns } from "./RefundHistoryList.vue?vue&type=template&id=80e5345e"
import script from "@/controllers/custom/refund/refund-history-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/refund/refund-history-list.js?vue&type=script&lang=js&external"
import style0 from "./RefundHistoryList.vue?vue&type=style&index=0&id=80e5345e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports